import { validEvidence } from './evidenceValidation';
import { evidenceHandoffCopy } from './evidenceHandoffCopy';

const references = [
  {symbol: 'POL', proxy: '0xAB594600376Ec9fD91F8e885dADF0CE036862dE0', source: 'https://data.chain.link/feeds/polygon/mainnet/matic-usd'},
  {symbol: 'USDC', proxy: '0xfE4A8cc5b5B2366C1B58Bea3858e81843581b2F7', source: 'https://data.chain.link/feeds/polygon/mainnet/usdc-usd'}
];
const fields = ['status','checked_at','expires_at','aggregator','proxy_code_hash','aggregator_code_hash',
  'description','decimals','answer','price18','round_id','updated_at','block_number','block_hash','block_timestamp'];

// Export only public feed provenance already in the authorized view, never its raw object.
export const makeReviewPacket = (value, context, language) => {
  if (!validEvidence(value, context)) throw new Error('Invalid evidence');
  const now = Date.now(), copy = evidenceHandoffCopy[language] || evidenceHandoffCopy.en;
  return {
    schema: 'stg-feed-review-request-v1', language: language === 'es' ? 'es' : 'en',
    generated_at_utc: new Date(now).toISOString(), status: 'draft_unreviewed',
    reviewer: null, independent_decision: null, approved_binding: null,
    deployment_binding: null, historical_block_range: null,
    fee_review_blocked: true, collection_enabled: false, signing_enabled: false, execution_enabled: false,
    provider_settlement_evidence: 'pending_not_included',
    provenance: 'Local export of observations, not a signed statement, live price, approval or complete historical proof. Independently reproduce every value.',
    application_policy_not_upstream_configuration: {
      maximum_observation_age_seconds: 180, display_lifetime_seconds: 60,
      usdc_safety_band_usd: ['0.99', '1.01']
    },
    feeds: references.map(reference => {
      const feed = value.feeds.find(f => f.symbol === reference.symbol);
      const observation = feed ? Object.fromEntries(fields.map(key => [key, feed[key]])) : null;
      return {...reference, chain_id: 137, upstream_heartbeat_seconds: null, upstream_deviation_percent: null,
        independent_review_status: 'pending', fee_eligible: false, observation,
        observation_state_at_export: !feed ? 'not_observed' : feed.expires_at * 1000 <= now ? 'expired' : feed.status,
        derived_phase_id: feed?.round_id ? (BigInt(feed.round_id) >> 64n).toString() : null,
        derived_aggregator_round_id: feed?.round_id ? (BigInt(feed.round_id) & ((1n << 64n) - 1n)).toString() : null};
    }),
    independent_review_requirements: copy.reviewQuestions,
    documentation: ['https://docs.chain.link/data-feeds/historical-data', 'https://docs.chain.link/data-feeds/api-reference']
  };
};

export const downloadEvidenceDraft = (filename, content, type) => {
  const url = URL.createObjectURL(new Blob([content], {type}));
  const link = document.createElement('a');
  link.href = url; link.download = filename; link.dataset.testid = 'evidence-generated-download';
  try { document.body.appendChild(link); link.click(); }
  finally { link.remove(); window.setTimeout(() => URL.revokeObjectURL(url), 1000); }
};